import { render, staticRenderFns } from "./ShippingGeneralSetting.vue?vue&type=template&id=966c3fc6&scoped=true&"
import script from "./ShippingGeneralSetting.vue?vue&type=script&lang=js&"
export * from "./ShippingGeneralSetting.vue?vue&type=script&lang=js&"
import style0 from "./ShippingGeneralSetting.vue?vue&type=style&index=0&id=966c3fc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966c3fc6",
  null
  
)

export default component.exports